// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f5qe6k1 {
  width: 100%;
}
.f5qe6k2 {
  gap: 20px 40px;
}
.f5qe6k3 {
  font-size: 15px;
  color: #9b9b9b;
}
.f5qe6k4:hover {
  text-decoration: underline;
}
.f5qe6k5 {
  width: 82.5%;
}
.f5qe6k6:hover {
  text-decoration: underline;
}
.f5qe6k7 {
  max-width: 17.5%;
}
.f5qe6k8 {
  display: flex;
  flex-direction: column;
}
.f5qe6k9 {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 0px;
}
.f5qe6ka {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  border-top-left-radius: var(--_18w76bw4r);
  border-top-right-radius: var(--_18w76bw4r);
  background-color: var(--_18w76bw2w);
}
.f5qe6kb {
  color: white;
  margin-left: 8px;
  margin-right: 8px;
}
.f5qe6kc {
  display: flex;
  border: 2px solid var(--_18w76bw2w);
  border-bottom-left-radius: var(--_18w76bw4q);
  border-bottom-right-radius: var(--_18w76bw4q);
  background-color: var(--_18w76bw23);
}
.f5qe6kd {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-right: 8px;
  flex-grow: 1;
  padding: 0;
}
.f5qe6ke {
  display: flex;
  flex-direction: row;
  padding: 16px;
}
.f5qe6kf {
  flex-shrink: 0;
  object-fit: contain;
  max-height: 160px;
  padding-right: 8px;
  display: block;
  width: 100%;
  height: auto;
}
.f5qe6kg {
  border: 2px solid;
  width: 28px;
  line-height: var(--_18w76bw45);
  text-align: center;
  align-self: center;
}
.f5qe6kh {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0px;
}
.f5qe6ki {
  color: var(--_18w76bw2w);
  font-weight: bold;
  align-self: center;
}
.f5qe6kj {
  font-size: var(--_18w76bw3n);
}
.f5qe6kk {
  display: flex;
  align-items: flex-end;
}
@media screen and (min-width: 768px) {
  .f5qe6k0 {
    position: relative;
    left: calc(50% + 10px);
  }
  .f5qe6k1 {
    width: calc(50% - 10px);
  }
  .f5qe6k3 {
    font-size: 17px;
    font-weight: 500;
  }
}
@media (min-width: 768px) {
  .f5qe6k5 {
    width: calc(42.5% - 100px);
    flex-grow: 1;
    padding-left: var(--_18w76bwm);
  }
  .f5qe6k7 {
    max-width: var(--_18w76bw13);
    min-height: var(--_18w76bw13);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;EAC5C,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF","sourcesContent":[".f5qe6k1 {\n  width: 100%;\n}\n.f5qe6k2 {\n  gap: 20px 40px;\n}\n.f5qe6k3 {\n  font-size: 15px;\n  color: #9b9b9b;\n}\n.f5qe6k4:hover {\n  text-decoration: underline;\n}\n.f5qe6k5 {\n  width: 82.5%;\n}\n.f5qe6k6:hover {\n  text-decoration: underline;\n}\n.f5qe6k7 {\n  max-width: 17.5%;\n}\n.f5qe6k8 {\n  display: flex;\n  flex-direction: column;\n}\n.f5qe6k9 {\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  gap: 0px;\n}\n.f5qe6ka {\n  display: flex;\n  flex-direction: row;\n  align-content: flex-start;\n  border-top-left-radius: var(--_18w76bw4r);\n  border-top-right-radius: var(--_18w76bw4r);\n  background-color: var(--_18w76bw2w);\n}\n.f5qe6kb {\n  color: white;\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.f5qe6kc {\n  display: flex;\n  border: 2px solid var(--_18w76bw2w);\n  border-bottom-left-radius: var(--_18w76bw4q);\n  border-bottom-right-radius: var(--_18w76bw4q);\n  background-color: var(--_18w76bw23);\n}\n.f5qe6kd {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-right: 8px;\n  flex-grow: 1;\n  padding: 0;\n}\n.f5qe6ke {\n  display: flex;\n  flex-direction: row;\n  padding: 16px;\n}\n.f5qe6kf {\n  flex-shrink: 0;\n  object-fit: contain;\n  max-height: 160px;\n  padding-right: 8px;\n  display: block;\n  width: 100%;\n  height: auto;\n}\n.f5qe6kg {\n  border: 2px solid;\n  width: 28px;\n  line-height: var(--_18w76bw45);\n  text-align: center;\n  align-self: center;\n}\n.f5qe6kh {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-bottom: 0px;\n}\n.f5qe6ki {\n  color: var(--_18w76bw2w);\n  font-weight: bold;\n  align-self: center;\n}\n.f5qe6kj {\n  font-size: var(--_18w76bw3n);\n}\n.f5qe6kk {\n  display: flex;\n  align-items: flex-end;\n}\n@media screen and (min-width: 768px) {\n  .f5qe6k0 {\n    position: relative;\n    left: calc(50% + 10px);\n  }\n  .f5qe6k1 {\n    width: calc(50% - 10px);\n  }\n  .f5qe6k3 {\n    font-size: 17px;\n    font-weight: 500;\n  }\n}\n@media (min-width: 768px) {\n  .f5qe6k5 {\n    width: calc(42.5% - 100px);\n    flex-grow: 1;\n    padding-left: var(--_18w76bwm);\n  }\n  .f5qe6k7 {\n    max-width: var(--_18w76bw13);\n    min-height: var(--_18w76bw13);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
